import { render } from "./ExportItem.vue?vue&type=template&id=2fb5b4b4"
import script from "./ExportItem.vue?vue&type=script&lang=js"
export * from "./ExportItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__